<template>
  <ul class="flex flex-col gap-6 mb-6">
    <li class="flex gap-4 animate-pulse">
      <div class="rounded-full w-8 h-8 bg-slate-100 dark:bg-zinc-800"></div>
      <div class="flex flex-col flex-grow gap-1">
        <div class="flex justify-between">
          <div class="h-4 w-2/6 rounded bg-slate-100 dark:bg-zinc-800"></div>
          <div class="h-4 w-1/6 rounded bg-slate-100 dark:bg-zinc-800"></div>
        </div>
        <div class="w-1/2 h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </li>
    <li class="flex gap-4 animate-pulse">
      <div class="rounded-full w-8 h-8 bg-slate-100 dark:bg-zinc-800"></div>
      <div class="flex flex-col flex-grow gap-1">
        <div class="flex justify-between">
          <div class="h-4 w-2/6 rounded bg-slate-100 dark:bg-zinc-800"></div>
          <div class="h-4 w-1/6 rounded bg-slate-100 dark:bg-zinc-800"></div>
        </div>
        <div class="w-1/2 h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </li>
  </ul>

  <div class="h-4 w-2/6 animate-pulse rounded mb-2 bg-slate-100 dark:bg-zinc-800"></div>
  <div class="h-9 w-full animate-pulse space-x-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
</template>

<script lang="ts" setup></script>
